<section class="w3-section filter">
  <div class="filter-search">
    <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
    <input
      type="search"
      class="app-input filter-search-input"
      autocomplete="off"
      [attr.aria-label]="'filter.label.fieldSearch' | translate"
      [placeholder]="'filter.label.fieldSearch' | translate"
      [ngModel]="fieldSearch"
      (ngModelChange)="fieldSearch = $event"
    />
  </div>
  <div class="filter-groups">
    @for (group of groups; track group.key) {
      @let keys = shownFields(group.key, fieldSearch);
      @if (keys.length) {
        @let open = isOpen(group.key, fieldSearch);
        @let count = activeCount(group.key);
        <section
          class="filter-group"
          [class.open]="open"
          [attr.aria-label]="group.label | translate"
        >
          <h3 class="filter-group-title">
            <button
              type="button"
              class="filter-group-toggle"
              [attr.aria-expanded]="open"
              [attr.aria-controls]="'filter-group-' + group.key"
              [disabled]="!!fieldSearch.trim()"
              (click)="toggleGroup(group.key)"
            >
              <i
                class="fa-solid fa-chevron-right filter-group-chevron"
                aria-hidden="true"
              ></i>
              <span class="filter-group-label">{{
                group.label | translate
              }}</span>
              @if (count) {
                <span
                  class="filter-group-count"
                  [attr.aria-label]="
                    'filter.label.activeCount' | translate: { count }
                  "
                  >{{ count }}</span
                >
              }
            </button>
          </h3>
          @if (!open && count) {
            <p class="filter-group-summary">
              @for (label of activeFields(group.key); track label) {
                <span>{{ label | translate }}</span>
              }
            </p>
          }
          @if (open) {
            <div class="filter-group-fields" [id]="'filter-group-' + group.key">
              @for (key of keys; track key) {
                <div class="filter-field">
                  @switch (key) {
                    @case ('name') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.name' | translate }}
                        </div>
                        <span class="clearable-input">
                          <input
                            aria-label="Name"
                            type="text"
                            class="app-input filter-input"
                            [(ngModel)]="simpleFilterValues.name"
                            (ngModelChange)="
                              simpleFilterChanged('name', 'contains')
                            "
                            (keydown.enter)="enterPressed()"
                          />
                          @if (simpleFilterValues.name) {
                            <i
                              class="app-icon fa-solid fa-xmark clear-icon"
                              role="button"
                              tabindex="0"
                              aria-label="Clear"
                              (click)="clearTextFilter('name')"
                              (keydown.enter)="clearTextFilter('name')"
                              (keydown.space)="
                                $event.preventDefault(); clearTextFilter('name')
                              "
                            ></i>
                          }
                        </span>
                      </div>
                    }
                    @case ('sectors') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.sectors' | translate }}
                        </div>
                        @if (sectors$ | async; as sectors) {
                          <app-multi-select
                            ariaLabel="Subsector"
                            #sectorsSelect
                            styleClass="filter-input"
                            placeholder="Select..."
                            [filter]="true"
                            [showClear]="true"
                            [showToggleAll]="true"
                            [options]="sectors"
                            optionLabel="name"
                            optionValue="id"
                            [(ngModel)]="simpleFilterValues.sectors"
                            (ngModelChange)="
                              simpleFilterChanged(
                                'sectors',
                                'anyof',
                                sectorsSelect
                              )
                            "
                          >
                            <ng-template
                              appSelectTemplate="selectedItems"
                              let-values
                            >
                              @if (values?.length) {
                                @if (values.length <= 1) {
                                  @for (value of values; track value) {
                                    <span class="app-multi-select-token">
                                      <span
                                        class="app-multi-select-token-label"
                                        >{{ sectorName(sectors, value) }}</span
                                      >
                                      <span
                                        class="app-multi-select-token-icon app-icon fa-solid fa-circle-xmark"
                                        role="button"
                                        tabindex="0"
                                        aria-label="Remove"
                                        (click)="
                                          removeTag(
                                            $event,
                                            'sectors',
                                            'anyof',
                                            value
                                          )
                                        "
                                        (keydown.enter)="
                                          removeTag(
                                            $event,
                                            'sectors',
                                            'anyof',
                                            value
                                          )
                                        "
                                        (keydown.space)="
                                          $event.preventDefault();
                                          removeTag(
                                            $event,
                                            'sectors',
                                            'anyof',
                                            value
                                          )
                                        "
                                      ></span>
                                    </span>
                                  }
                                } @else {
                                  <span class="app-multi-select-token">
                                    <span class="app-multi-select-token-label"
                                      >{{ values.length }} selected</span
                                    >
                                  </span>
                                }
                              } @else {
                                <span class="app-placeholder">Select...</span>
                              }
                            </ng-template>
                          </app-multi-select>
                        }
                      </div>
                    }
                    @case ('country_code') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.country_code' | translate }}
                        </div>
                        @if (countryCodes$ | async; as countryCodes) {
                          <app-multi-select
                            ariaLabel="Country"
                            #country_codeSelect
                            styleClass="filter-input"
                            placeholder="Select..."
                            [filter]="true"
                            [showClear]="true"
                            [showToggleAll]="true"
                            [options]="countryCodes"
                            optionLabel="label"
                            optionValue="value"
                            [(ngModel)]="simpleFilterValues.country_code"
                            (ngModelChange)="
                              simpleFilterChanged(
                                'country_code',
                                'in',
                                country_codeSelect
                              )
                            "
                          >
                            <ng-template
                              appSelectTemplate="selectedItems"
                              let-values
                            >
                              @if (values?.length) {
                                @if (values.length <= 5) {
                                  @for (value of values; track value) {
                                    <span class="app-multi-select-token">
                                      <span
                                        class="app-multi-select-token-label"
                                        >{{ value }}</span
                                      >
                                      <span
                                        class="app-multi-select-token-icon app-icon fa-solid fa-circle-xmark"
                                        role="button"
                                        tabindex="0"
                                        aria-label="Remove"
                                        (click)="
                                          removeTag(
                                            $event,
                                            'country_code',
                                            'in',
                                            value
                                          )
                                        "
                                        (keydown.enter)="
                                          removeTag(
                                            $event,
                                            'country_code',
                                            'in',
                                            value
                                          )
                                        "
                                        (keydown.space)="
                                          $event.preventDefault();
                                          removeTag(
                                            $event,
                                            'country_code',
                                            'in',
                                            value
                                          )
                                        "
                                      ></span>
                                    </span>
                                  }
                                } @else {
                                  <span class="app-multi-select-token">
                                    <span class="app-multi-select-token-label"
                                      >{{ values.length }} selected</span
                                    >
                                  </span>
                                }
                              } @else {
                                <span class="app-placeholder">Select...</span>
                              }
                            </ng-template>
                          </app-multi-select>
                        }
                      </div>
                    }
                    @case ('city') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.city' | translate }}
                        </div>
                        <span class="clearable-input">
                          <input
                            aria-label="City"
                            type="text"
                            class="app-input filter-input"
                            [(ngModel)]="simpleFilterValues.city"
                            (ngModelChange)="
                              simpleFilterChanged('city', 'contains')
                            "
                            (keydown.enter)="enterPressed()"
                          />
                          @if (simpleFilterValues.city) {
                            <i
                              class="app-icon fa-solid fa-xmark clear-icon"
                              role="button"
                              tabindex="0"
                              aria-label="Clear"
                              (click)="clearTextFilter('city')"
                              (keydown.enter)="clearTextFilter('city')"
                              (keydown.space)="
                                $event.preventDefault(); clearTextFilter('city')
                              "
                            ></i>
                          }
                        </span>
                      </div>
                    }
                    @case ('founded_at') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.founded_at' | translate }}
                        </div>
                        <div class="editor-row">
                          <app-date-input
                            ariaLabel="Founded from"
                            styleClass="filter-input"
                            placeholder="Start Date"
                            [showIcon]="true"
                            [showClear]="true"
                            [ngModel]="
                              simpleFilterValues.founded_atFrom || null
                            "
                            (ngModelChange)="
                              simpleFilterValues.founded_atFrom = $event;
                              simpleFilterChanged('founded_at', 'between')
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-date-input>
                          <app-date-input
                            ariaLabel="Founded to"
                            styleClass="filter-input"
                            placeholder="End Date"
                            [showIcon]="true"
                            [showClear]="true"
                            [ngModel]="simpleFilterValues.founded_atTo || null"
                            (ngModelChange)="
                              simpleFilterValues.founded_atTo = $event;
                              simpleFilterChanged('founded_at', 'between')
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-date-input>
                        </div>
                      </div>
                    }
                    @case ('ownership_type') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.ownership_type' | translate }}
                        </div>
                        <app-select
                          ariaLabel="Ownership type"
                          styleClass="filter-input"
                          placeholder="Select..."
                          [showClear]="true"
                          [options]="[
                            'Private',
                            'Venture Capital',
                            'Private Equity',
                            'Public Sub',
                            'Non-Profit',
                            'Public',
                            'Seed',
                            'Private Sub',
                            'Gov Agency',
                            'Joint Venture',
                            'Edu',
                            'Other',
                          ]"
                          [(ngModel)]="simpleFilterValues.ownership_type"
                          (ngModelChange)="
                            simpleFilterChanged('ownership_type', '=')
                          "
                        ></app-select>
                      </div>
                    }
                    @case ('keywords') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.keywords' | translate }}
                        </div>
                        <app-chips
                          ariaLabel="Keywords"
                          styleClass="filter-input"
                          placeholder="Enter Keywords"
                          [addOnBlur]="true"
                          [allowDuplicate]="false"
                          [showClear]="true"
                          [(ngModel)]="simpleFilterValues.keywords"
                          (ngModelChange)="
                            simpleFilterChanged('keywords', 'contains')
                          "
                        ></app-chips>
                      </div>
                    }
                    @case ('last_employee_count') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.last_employee_count' | translate }}
                        </div>
                        <div class="editor-row">
                          <app-number-input
                            ariaLabel="Employees from"
                            styleClass="filter-input"
                            placeholder="from"
                            locale="en-GB"
                            [maxFractionDigits]="0"
                            [showClear]="true"
                            [(ngModel)]="
                              simpleFilterValues.last_employee_countFrom
                            "
                            (ngModelChange)="
                              simpleFilterChanged(
                                'last_employee_count',
                                'between'
                              )
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                          <app-number-input
                            ariaLabel="Employees to"
                            styleClass="filter-input"
                            placeholder="to"
                            locale="en-GB"
                            [maxFractionDigits]="0"
                            [showClear]="true"
                            [(ngModel)]="
                              simpleFilterValues.last_employee_countTo
                            "
                            (ngModelChange)="
                              simpleFilterChanged(
                                'last_employee_count',
                                'between'
                              )
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                        </div>
                      </div>
                    }
                    @case ('last_employee_growth') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.last_employee_growth' | translate }}
                        </div>
                        <div class="editor-row">
                          <app-number-input
                            ariaLabel="Latest employee growth (%) from"
                            styleClass="filter-input"
                            placeholder="from"
                            locale="en-GB"
                            suffix="%"
                            [maxFractionDigits]="0"
                            [showClear]="true"
                            [(ngModel)]="
                              simpleFilterValues.last_employee_growthFrom
                            "
                            (ngModelChange)="
                              simpleFilterChanged(
                                'last_employee_growth',
                                'between'
                              )
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                          <app-number-input
                            ariaLabel="Latest employee growth (%) to"
                            styleClass="filter-input"
                            placeholder="to"
                            locale="en-GB"
                            suffix="%"
                            [maxFractionDigits]="0"
                            [showClear]="true"
                            [(ngModel)]="
                              simpleFilterValues.last_employee_growthTo
                            "
                            (ngModelChange)="
                              simpleFilterChanged(
                                'last_employee_growth',
                                'between'
                              )
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                        </div>
                      </div>
                    }
                    @case ('revenue') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.revenue' | translate }}
                        </div>
                        <div class="editor-row">
                          <app-number-input
                            ariaLabel="Revenue ($) from"
                            styleClass="filter-input"
                            placeholder="from"
                            locale="en-GB"
                            prefix="$ "
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [showClear]="true"
                            [(ngModel)]="simpleFilterValues.revenueFrom"
                            (ngModelChange)="
                              simpleFilterChanged('revenue', 'between')
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                          <app-number-input
                            ariaLabel="Revenue ($) to"
                            styleClass="filter-input"
                            placeholder="to"
                            locale="en-GB"
                            prefix="$ "
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [showClear]="true"
                            [(ngModel)]="simpleFilterValues.revenueTo"
                            (ngModelChange)="
                              simpleFilterChanged('revenue', 'between')
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                        </div>
                      </div>
                    }
                    @case ('last_ebitda') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.last_ebitda' | translate }}
                        </div>
                        <div class="editor-row">
                          <app-number-input
                            ariaLabel="Latest EBITDA ($) from"
                            styleClass="filter-input"
                            placeholder="from"
                            locale="en-GB"
                            prefix="$ "
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [showClear]="true"
                            [(ngModel)]="simpleFilterValues.last_ebitdaFrom"
                            (ngModelChange)="
                              simpleFilterChanged('last_ebitda', 'between')
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                          <app-number-input
                            ariaLabel="Latest EBITDA ($) to"
                            styleClass="filter-input"
                            placeholder="to"
                            locale="en-GB"
                            prefix="$ "
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [showClear]="true"
                            [(ngModel)]="simpleFilterValues.last_ebitdaTo"
                            (ngModelChange)="
                              simpleFilterChanged('last_ebitda', 'between')
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                        </div>
                      </div>
                    }
                    @case ('investors') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.investors' | translate }}
                        </div>
                        <span class="clearable-input">
                          <input
                            aria-label="Investor"
                            type="text"
                            class="app-input filter-input"
                            [(ngModel)]="simpleFilterValues.investors"
                            (ngModelChange)="
                              simpleFilterChanged('investors', 'contains')
                            "
                            (keydown.enter)="enterPressed()"
                          />
                          @if (simpleFilterValues.investors) {
                            <i
                              class="app-icon fa-solid fa-xmark clear-icon"
                              role="button"
                              tabindex="0"
                              aria-label="Clear"
                              (click)="clearTextFilter('investors')"
                              (keydown.enter)="clearTextFilter('investors')"
                              (keydown.space)="
                                $event.preventDefault();
                                clearTextFilter('investors')
                              "
                            ></i>
                          }
                        </span>
                      </div>
                    }
                    @case ('last_investment_amount') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{
                            'filter.field.last_investment_amount' | translate
                          }}
                        </div>
                        <div class="editor-row">
                          <app-number-input
                            ariaLabel="Latest funded amount ($) from"
                            styleClass="filter-input"
                            placeholder="from"
                            locale="en-GB"
                            prefix="$ "
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [showClear]="true"
                            [(ngModel)]="
                              simpleFilterValues.last_investment_amountFrom
                            "
                            (ngModelChange)="
                              simpleFilterChanged(
                                'last_investment_amount',
                                'between'
                              )
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                          <app-number-input
                            ariaLabel="Latest funded amount ($) to"
                            styleClass="filter-input"
                            placeholder="to"
                            locale="en-GB"
                            prefix="$ "
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [showClear]="true"
                            [(ngModel)]="
                              simpleFilterValues.last_investment_amountTo
                            "
                            (ngModelChange)="
                              simpleFilterChanged(
                                'last_investment_amount',
                                'between'
                              )
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                        </div>
                      </div>
                    }
                    @case ('last_funded_year') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.last_funded_year' | translate }}
                        </div>
                        <div class="editor-row">
                          <app-date-input
                            ariaLabel="Latest funded year from"
                            styleClass="filter-input"
                            placeholder="Start Date"
                            view="year"
                            [showIcon]="true"
                            [showClear]="true"
                            [ngModel]="
                              simpleFilterValues.last_funded_yearFrom || null
                            "
                            (ngModelChange)="
                              simpleFilterValues.last_funded_yearFrom = $event;
                              simpleFilterChanged('last_funded_year', 'between')
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-date-input>
                          <app-date-input
                            ariaLabel="Latest funded year to"
                            styleClass="filter-input"
                            placeholder="End Date"
                            view="year"
                            [showIcon]="true"
                            [showClear]="true"
                            [ngModel]="
                              simpleFilterValues.last_funded_yearTo || null
                            "
                            (ngModelChange)="
                              simpleFilterValues.last_funded_yearTo = $event;
                              simpleFilterChanged('last_funded_year', 'between')
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-date-input>
                        </div>
                      </div>
                    }
                    @case ('attractiveness_score') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.attractiveness_score' | translate }}
                        </div>
                        <div class="editor-row">
                          <app-number-input
                            ariaLabel="Score from"
                            styleClass="filter-input"
                            placeholder="from"
                            locale="en-GB"
                            [maxFractionDigits]="0"
                            [showClear]="true"
                            [(ngModel)]="
                              simpleFilterValues.attractiveness_scoreFrom
                            "
                            (ngModelChange)="
                              simpleFilterChanged(
                                'attractiveness_score',
                                'between'
                              )
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                          <app-number-input
                            ariaLabel="Score to"
                            styleClass="filter-input"
                            placeholder="to"
                            locale="en-GB"
                            [maxFractionDigits]="0"
                            [showClear]="true"
                            [(ngModel)]="
                              simpleFilterValues.attractiveness_scoreTo
                            "
                            (ngModelChange)="
                              simpleFilterChanged(
                                'attractiveness_score',
                                'between'
                              )
                            "
                            (keydown.enter)="enterPressed()"
                          ></app-number-input>
                        </div>
                      </div>
                    }
                    @case ('review_status') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.review_status' | translate }}
                        </div>
                        <app-select
                          ariaLabel="Review status"
                          styleClass="filter-input"
                          placeholder="Select..."
                          [showClear]="true"
                          [options]="[
                            'Interesting - added to DealCloud',
                            'Interesting - not added to DealCloud',
                            'Not interesting',
                            'Not reviewed',
                          ]"
                          [(ngModel)]="simpleFilterValues.review_status"
                          (ngModelChange)="
                            simpleFilterChanged('review_status', '=')
                          "
                        ></app-select>
                      </div>
                    }
                    @case ('reviewer') {
                      <div class="filter-cell">
                        <div class="filter-field-label">
                          {{ 'filter.field.reviewer' | translate }}
                        </div>
                        <span class="clearable-input">
                          <input
                            aria-label="Reviewer"
                            type="text"
                            class="app-input filter-input"
                            [(ngModel)]="simpleFilterValues.reviewer"
                            (ngModelChange)="
                              simpleFilterChanged('reviewer', 'contains')
                            "
                            (keydown.enter)="enterPressed()"
                          />
                          @if (simpleFilterValues.reviewer) {
                            <i
                              class="app-icon fa-solid fa-xmark clear-icon"
                              role="button"
                              tabindex="0"
                              aria-label="Clear"
                              (click)="clearTextFilter('reviewer')"
                              (keydown.enter)="clearTextFilter('reviewer')"
                              (keydown.space)="
                                $event.preventDefault();
                                clearTextFilter('reviewer')
                              "
                            ></i>
                          }
                        </span>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }
        </section>
      }
    }
  </div>
</section>
